import { render, staticRenderFns } from "./ProductNote.vue?vue&type=template&id=2e2e2bf7"
import script from "./ProductNote.vue?vue&type=script&lang=js"
export * from "./ProductNote.vue?vue&type=script&lang=js"
import style0 from "./ProductNote.vue?vue&type=style&index=0&id=2e2e2bf7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports